export class Comment {
    ident:number;
    game:string;
    username:string;
    text:string;
    commented_on:Date;
}
